import { format } from 'date-fns'

const ICON_MAP = {
  ClickableImage: 'image',
  Competition: 'trophy',
  Discourse: 'lightbulb',
  FreeTextPoll: 'free-text-poll',
  MultipleChoicePoll: 'multiple-choice-poll',
  RankingPoll: 'ranking-poll',
  Survey: 'survey'
}
function activityTypeToIcon (type) {
  return (type && type in ICON_MAP) ? ICON_MAP[type] : ''
}

function responsePollGlyph (poll) {
  return poll.competition_id
    ? activityTypeToIcon('Competition')
    : activityTypeToIcon(poll.type)
}

export function responseToListItem (response) {
  return {
    id: response.id,
    title: response.poll.title,
    subtitles: [response.humanized_value],
    glyph: responsePollGlyph(response.poll)
  }
}

export function humanWhen (createdAt) {
  return format(new Date(createdAt), 'MMM d, yyyy \'at\' h:mma')
}
